import { invalidateCachedLocalAlbumDetail } from './albumDetailCache';
import { normalizeLocalAlbumId } from './localLibraryMetadata';

/** Remove a deleted local album from recents + detail cache (class fix, not per-id). */
export function purgeStaleLocalAlbumRef(albumId: string): void {
  const normalized = normalizeLocalAlbumId(String(albumId || '').trim());
  if (!normalized) return;
  invalidateCachedLocalAlbumDetail(normalized);

  // Lazy import breaks recentAlbumsStore ↔ localLibraryRefValidator ↔ libraryService cycle.
  void import('../store/recentAlbumsStore').then(({ useRecentAlbumsStore }) => {
    const store = useRecentAlbumsStore.getState();
    store.removeRecent(normalized);
    const raw = String(albumId || '').trim();
    if (raw && raw !== normalized) store.removeRecent(raw);
  });
}
